module.exports = __webpack_public_path__ + "components/app-promo/static/background-app-page-d88835e5d7a5f646f38399eeaa003e15.jpg";